import React from 'react';
import styled from 'styled-components';
import { Container, Heading1 } from '../components/common';
import { ContactForm } from '../components/Contacts/ContactForm';
import { SeoTags } from '../components/SeoTags';
import { Email as EmailIcon, Phone as PhoneIcon, Logo } from '../icons';
import { colors, media } from '../utils/styles';

const ContactsPage = ({ pageContext: { content } }) => {
  return (
    <>
      <SeoTags
        title="About Us"
        description={`We are inventive, people-focused nutrition company who believe that happiness and wellness go hand in hand. It's our goal to help you reach your nutrition goals while enjoying your daily supplements.`}
      />
      <ContactsSection>
        <Container>
          <AboutHeading>{content.about_us_heading}</AboutHeading>
          <AboutText dangerouslySetInnerHTML={{ __html: content.about_us_text.html }} />
          <Heading as="h2">{content.heading}</Heading>
          <ContactsRow>
            <ContactsCol>
              <EmailIcon />
              <div>
                <ContactsTitle>Email us at.</ContactsTitle>
                <ContactsContent>We’ll try to respond within the next working day.</ContactsContent>
                <ContactsLink href="mailto:hello@reshape.me">hello@reshape.me</ContactsLink>
              </div>
            </ContactsCol>
            <ContactsCol>
              <PhoneIcon />
              <div>
                <ContactsTitle>Give us.</ContactsTitle>
                <ContactsContent>We’re here to answer your questions here and now.</ContactsContent>
                <ContactsLink href="tel:+1(302) 209-7110">+1(302) 209-7110</ContactsLink>
              </div>
            </ContactsCol>
            {/* <ContactsCol>
              <ChatIcon />
              <div>
                <ContactsTitle>Chat live.</ContactsTitle>
                <ContactsContent>Our live chat is available 24/7.</ContactsContent>
                <ContactsLink href="mailto:help@reshape.com">Chat now</ContactsLink>
              </div>
            </ContactsCol> */}
          </ContactsRow>
        </Container>
      </ContactsSection>
      <FormSection>
        <Container>
          <FormSectionRow>
            <ContactForm />
            <FormSectionContent>
              <Logo />
              <FormSectionText dangerouslySetInnerHTML={{ __html: content.contacts.html }} />
            </FormSectionContent>
          </FormSectionRow>
        </Container>
      </FormSection>
    </>
  );
};

const AboutText = styled.div`
  margin: 0 auto 150px;
  width: 750px;
  max-width: 100%;
  line-height: 1.8;
  ${media.phone} {
    margin: 0 auto 50px;
  }
  p {
    margin: 0 0 30px;
  }
  strong {
    font-weight: 700;
  }
  em {
    font-style: normal;
    color: ${colors.pink};
  }
  a {
    color: ${colors.pink};
    text-decoration: underline;
  }
`;

const FormSectionRow = styled.div`
  display: flex;
  ${media.phone} {
    flex-wrap: wrap;
  }
`;

const FormSection = styled.section`
  background: #ecf6ff;
  padding: 100px 0;
  ${media.phone} {
    padding: 60px 0;
  }
`;

const FormSectionContent = styled.div`
  margin-left: 120px;
  flex: 1;
  padding-top: 40px;
  ${media.tablet} {
    margin-left: 40px;
  }
  ${media.phone} {
    margin: 0;
  }
`;

const FormSectionText = styled.div`
  color: #697f93;
  margin-top: 32px;
  font-size: 15px;
  line-height: 26px;
`;

const Heading = styled(Heading1)`
  margin: 0 0 150px;
  ${media.phone} {
    margin: 0 0 50px;
  }
`;

const AboutHeading = styled(Heading)`
  margin: 0 0 100px;
  ${media.phone} {
    margin: 0 0 50px;
  }
`;

const ContactsSection = styled.section`
  padding: 200px 0 150px;
  ${media.phone} {
    padding: 150px 0 60px;
  }
`;

const ContactsRow = styled.div`
  display: flex;
  justify-content: space-evenly;
  ${media.tablet} {
    flex-direction: column;
    align-items: center;
    gap: 50px;
  }
`;

const ContactsTitle = styled.h5`
  font-weight: 500;
  font-size: 16px;
  line-height: 18px;
  color: #171616;
  margin: 0 0 10px;
`;

const ContactsCol = styled.div`
  display: inline-flex;
  > svg {
    margin-right: 19px;
  }
  > div {
    width: 210px;
    display: flex;
    flex-direction: column;
  }
`;

const ContactsContent = styled.p`
  font-size: 16px;
  line-height: 132.19%;
  letter-spacing: -0.015em;
  color: #8b8b8b;
  margin: 0 0 20px;
`;

const ContactsLink = styled.a`
  text-decoration-line: underline;
  color: #dd3072;
  margin-top: auto;
`;

export default ContactsPage;
